import React, {useContext, useState} from "react";
import {Button, Checkbox, Form, Grid, Icon, Menu, Message, Modal,} from "semantic-ui-react";
import {MessageContext} from "#providers";
import {MessagingService} from "#services";
import {colors} from "#static/json";

interface Props {
  iconType: String;
}

const WebNotifications: React.FC<Props> = (props: Props) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [extra, setExtra] = useState("");
  const [accepted, setAccepted] = useState(false);
  const [toastList, setMessageContext] = useContext(MessageContext);

  const submitNotification = (e) => {
    e.preventDefault();
    if (accepted) {
      setLoading(true);
      const payload = {
        action: extra,
        date: new Date(),
        description: body,
        readStatus: false,
        dismiss: false,
        title: title,
      };
      MessagingService.sendBroadcastWeb(payload)
        .then((r) => {
          setMessageContext({
            id: 1,
            title: "Notificação enviada!",
            description: "A notificação foi enviada a todos os usuários",
            backgroundColor: colors.success,
            icon: "check",
          });
          setLoading(false);
        })
        .catch((e) => {
          setMessageContext({
            id: 1,
            title: "Erro ao enviar",
            description:
              "Houve um erro ao enviar a notificação para todos os usuários",
            backgroundColor: colors.error,
            icon: "exclamation circle",
          });
          setLoading(false);
        });
    }
  };

  return (
    <>
      <Modal
        closeOnDimmerClick={false}
        closeOnEscape={false}
        size={"large"}
        closeIcon
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        trigger={
          <Menu.Item className={"menuText"} as="a">
            {props.iconType == "EXPANDED" ? (
              <Grid>
                <Grid.Column
                  style={{ marginLeft: "1rem", marginRight: "1.5rem" }}
                >
                  <Icon
                    size={"large"}
                    name="bell outline"
                    style={{ paddingTop: "3px" }}
                  />
                </Grid.Column>
                <Grid.Column style={{ marginTop: "0.4rem" }}>
                  <span className="menuVertical__item">Web</span>
                </Grid.Column>
              </Grid>
            ) : (
              <Icon.Group size={"large"}>
                <Icon name="bell outline" />
              </Icon.Group>
            )}
          </Menu.Item>
        }
        open={open}
      >
        <Modal.Header>
          <span className="modal__header">
            Broadcast/Notificações Mata Nativa Web
          </span>
        </Modal.Header>
        <Modal.Content>
          <Form id="web-notification-form" onSubmit={submitNotification}>
            <Message
              color={"yellow"}
              icon="exclamation triangle"
              header="Envio de broadcast"
              content="Atenção! Notificações enviadas nessa categoria serão enviadas em broadcast para todos os usuários do Mata Nativa Web,
                            revise a mensagem atentamente antes de enviar."
              style={{
                marginBottom: "40px",
              }}
            />
            <Form.Field required>
              <label className="modal__label">Título da notificação: </label>
              <input
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
                placeholder="Título da notificação"
              />
            </Form.Field>

            <Form.Field required>
              <label className="modal__label">
                Corpo da notificação (Tags HTML são aceitas):
              </label>
              <Form.TextArea
                required
                onChange={(e) => setBody(e.target.value)}
                value={body}
                placeholder="Corpo da notificação"
              />
            </Form.Field>

            <Form.Field>
              <label className="modal__label">
                Link Extra - Opcional (Ex: link de vídeo no youtube ou postagem
                do blog):
              </label>
              <input
                value={extra}
                onChange={(e) => setExtra(e.target.value)}
                placeholder="Link Extra"
              />
            </Form.Field>
            <Form.Field required style={{ marginTop: "20px" }}>
              <Checkbox
                checked={accepted}
                onClick={() => setAccepted(!accepted)}
                className="modal__label"
                label="Confirmo que desejo enviar notificação para todos os dispositivos"
              />
            </Form.Field>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            color="black"
            className={"buttonCancel"}
            loading={loading}
            content={"Fechar"}
            onClick={() => setOpen(false)}
          />
          <Button loading={loading} type="submit" form="web-notification-form">
            Enviar Broadcast
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default WebNotifications;
